import { MajorCardId } from '#lib/domain/types.ts';

const CLOUDINARY_BASE_URL = 'https://res.cloudinary.com/woad-game/image/upload';

type Params = {
	path: string;
	width?: number;
};

const DEFAULT_CARD_WIDTH = 500;

type UrlParams = {
	folder: 'general' | 'cards';
	width: number;
	path: string;
};

const createUrl = ({ folder, width, path }: UrlParams) => {
	return `${CLOUDINARY_BASE_URL}/w_${width}/${folder}/${path}.webp`;
};

export const backgroundUrl = (width: number) =>
	`${CLOUDINARY_BASE_URL}/f_auto,q_auto:eco,w_${width}/general/background-desktop.webp`;

export const getCardImageUrl = ({ path, width = DEFAULT_CARD_WIDTH }: Params) =>
	createUrl({ folder: 'cards', width, path });

export const getMajorCardFrontImage = ({
	id,
	width = DEFAULT_CARD_WIDTH
}: {
	id: MajorCardId;
	width: number;
}) => getCardImageUrl({ path: `Major Arcana/${id}`, width });

export const getMajorCardCentreImage = ({
	id,
	width = DEFAULT_CARD_WIDTH
}: {
	id: MajorCardId;
	width: number;
}) => getCardImageUrl({ path: `Major Arcana Centres/${id}`, width });

export const majorCardBackImageUrl = 'Major Arcana/MAJOR_ARCANA_BACK';
